import { FileExcelOutlined, InboxOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Alert, message, Space, Typography, Upload, UploadProps } from "antd";
import { useState } from "react";
import { importAffiliateExcel } from "../../../../lib/api/resources/affiliates";
import { Button, Card } from "@rumbledirect/ui";

const { Dragger } = Upload;

interface AffiliateDataImportCardProps {
  loading: boolean;
}

export const AffiliateDataImportCard = ({
  loading,
}: AffiliateDataImportCardProps) => {
  const [file, setFile] = useState<File | null>(null);

  const mutation = useMutation({
    mutationFn: async () => {
      if (!file) throw new Error("Geen bestand geselecteerd");
      return importAffiliateExcel(file);
    },
    onSuccess: () => {
      message.success("Importeren van gegevens is geslaagd");
      setFile(null);
    },
    onError: () => message.error("Importeren mislukt"),
  });

  const props: UploadProps = {
    name: "file",
    multiple: false,
    beforeUpload: (f) => {
      setFile(f);
      return false;
    },
    accept:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
    maxCount: 1,
  };

  return (
    <Card title="Gegevens importeren" loading={loading}>
      <Space direction="vertical" style={{ width: "100%" }} size="large">
        <Alert
          type="info"
          showIcon
          message="Upload een Excel-bestand met gegevens om te importeren."
        />
        <Dragger {...props} disabled={mutation.isPending}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <Typography.Paragraph>
            Klik of sleep een Excel-bestand naar dit gebied om te uploaden
          </Typography.Paragraph>
        </Dragger>
        <div>
          <Button
            type="primary"
            onClick={() => mutation.mutate()}
            loading={mutation.isPending}
            disabled={!file}
            icon={<FileExcelOutlined />}
          >
            Importeren
          </Button>
        </div>
      </Space>
    </Card>
  );
};
